<form #formRef="ngForm" [ngClass]="{'preview-active': preview}">
	<bb-page-header [backOnMobile]="['/analytics/reports']" [tabItems]="tabItems" [icon]="'file'" [title]="entity?.title">
		<span class="subtitle"> {{ entity?.label }} </span>
		<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status" [labelOn]="'PUBLISHED' | translate"
			[labelOff]="'DRAFT' | translate"></bb-status>
	</bb-page-header>

	<div class="body-column tab-container" cdkScrollable>
		<report-details-contents *ngIf="entity && tabLoadedBefore('contents')" [report]="entity" [form]="form"
			[hidden]="activeTab !== 'contents'" (reportChanged)="reportChanged($event)">
		</report-details-contents>
		<report-details-schedule *ngIf="entity && tabLoadedBefore('schedule')" [report]="entity" [form]="form"
			[hidden]="activeTab !== 'schedule'">
		</report-details-schedule>
	</div>

	<div class="body-column preview-container">
		<h3>{{ 'SAMPLE' | translate }} <bb-info [contents]="'HELP.REPORT_PREVIEW' | translate"></bb-info>
		</h3>
		<div class="preview-wrapper" *ngIf="previewReportRows?.length">
			<table mat-table [dataSource]="previewReportRows" class="mat-elevation-z8">
				<ng-container [matColumnDef]="column" *ngFor="let column of selectedColumns">
					<th mat-header-cell *matHeaderCellDef> {{ getHeaderLabel(column) }} </th>
					<td mat-cell *matCellDef="let element" class="table-cell {{ getHeaderClass(type) }}"> {{ element[column] }} </td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="selectedColumns"></tr>
				<tr hide-in-percy mat-row *matRowDef="let row; columns: selectedColumns;"></tr>
			</table>
		</div>
		<bb-entity-details [entity]="entity"></bb-entity-details>
	</div>
</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form"
	[entity]="entity" [overrideAllowSave]="reportRights">
</bb-actions-bar>
